import React from "react";

const CommentIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M9.64048 0.0225422C7.03198 -0.159708 4.47823 0.794292 2.63623 2.63629C0.79423 4.47829 -0.158271 7.03129 0.0224795 9.64054C0.35248 14.406 4.57123 18 9.83473 18H14.2507C16.458 18 18 16.197 18 13.6148V9.25354C18 4.40179 14.328 0.347292 9.64048 0.0225422ZM12 9.75004H9.74998V12C9.74998 12.414 9.41398 12.75 8.99998 12.75C8.58598 12.75 8.24998 12.414 8.24998 12V9.75004H5.99998C5.58598 9.75004 5.24998 9.41404 5.24998 9.00004C5.24998 8.58604 5.58598 8.25004 5.99998 8.25004H8.24998V6.00004C8.24998 5.58604 8.58598 5.25004 8.99998 5.25004C9.41398 5.25004 9.74998 5.58604 9.74998 6.00004V8.25004H12C12.414 8.25004 12.75 8.58604 12.75 9.00004C12.75 9.41404 12.414 9.75004 12 9.75004Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CommentIcon;
